import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useParams, useRouteMatch } from 'react-router-dom';
import ContractualAccountDetailSection from 'features/contractualAccounts/sections/ContractualAccountDetailSection';
import ContractualAccountDetailLayoutPage from './ContractualAccountDetailLayoutPage';
import ContractualAccountDetailContractsSection from 'features/contractualAccounts/sections/ContractualAccountDetailContractsSection';
import ContractualAccountDetailInvoicesSection from 'features/contractualAccounts/sections/ContractualAccountDetailInvoicesSection';
import PaymentsOnDetailSection from 'features/payments/sections/PaymentsOnDetailSection';
import { useSearchParams } from 'features/shared/hooks/useSearchParams';
import ContractualAccountDetailFuelingContractsSection from '../sections/ContractualAccountDetailFuelingContractsSection';
import { containsFuelingParam } from 'features/shared/helpers/queryParams';

interface Props {
  contractualAccountId: string;
}

const ContractualAccountDetail = (props: Props) => {
  // translations
  const tModules = useTranslation("shared\\moduleNames").t;

  // router
  let match = useRouteMatch();
  const { contractualAccountId } = useParams<Props>();
  const searchParams = useSearchParams();

  // sub-renders
  const renderContractsSection = () => { 
    if (containsFuelingParam(searchParams)) {
      return (
        <ContractualAccountDetailFuelingContractsSection 
          contractualAccountId={contractualAccountId} 
        />
      );
    } else {
      return (
        <ContractualAccountDetailContractsSection 
          contractualAccountId={contractualAccountId} 
        />
      );
    }
  }

  // render
  return (
    <Switch>
      <Route path={`${match.path}/payments`}>
        <ContractualAccountDetailLayoutPage
          contractualAccountId={contractualAccountId}
          links={[{ text: tModules("contractualAccountDetailPayments.title") }]}
          isFueling={containsFuelingParam(searchParams)}
        >
          <PaymentsOnDetailSection 
            filterByName='ContractualAccountId'
            filterByValue={contractualAccountId}
          />
        </ContractualAccountDetailLayoutPage>
      </Route>
      <Route path={`${match.path}/invoices`}>
        <ContractualAccountDetailLayoutPage
          contractualAccountId={contractualAccountId}
          links={[{ text: tModules("contractualAccountDetailInvoices.title") }]}
          isFueling={containsFuelingParam(searchParams)}
        >
          <ContractualAccountDetailInvoicesSection 
            contractualAccountId={contractualAccountId} 
          />
        </ContractualAccountDetailLayoutPage>
      </Route>
      <Route path={`${match.path}/contracts`}>
        <ContractualAccountDetailLayoutPage
          contractualAccountId={contractualAccountId}
          links={[{ text: tModules("contractualAccountDetailContracts.title") }]}
          isFueling={containsFuelingParam(searchParams)}
        >
          {renderContractsSection()}
        </ContractualAccountDetailLayoutPage>
      </Route>
      <Route path={`${match.path}/detail`}>
        <ContractualAccountDetailLayoutPage
          contractualAccountId={contractualAccountId}
          links={[{ text: tModules("contractualAccountDetail.title") }]}
          showLinkToDetail={false}
          isFueling={containsFuelingParam(searchParams)}
        >
          <ContractualAccountDetailSection 
            contractualAccountId={contractualAccountId} 
          />
        </ContractualAccountDetailLayoutPage>
      </Route>
    </Switch>
  )
}

export default ContractualAccountDetail;
